'use client';

import PublicHeader from '@/components/common/PublicHeader';
import PublicFooter from '@/components/common/PublicFooter';
import ActivitiesReferenceContent from './ActivitiesReferenceContent';

export default function ActivitiesPage() {
  return (
    <>
      <PublicHeader data-component-id="src/app/activities/page.tsx:10:6" data-component-path="src/app/activities/page.tsx" data-component-line="10" data-component-end-line="10" data-component-file="page.tsx" data-component-name="PublicHeader" data-component-content="%7B%22elementName%22%3A%22PublicHeader%22%7D" />
      <main data-component-id="src/app/activities/page.tsx:11:6" data-component-path="src/app/activities/page.tsx" data-component-line="11" data-component-end-line="13" data-component-file="page.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%7D">
        <ActivitiesReferenceContent data-component-id="src/app/activities/page.tsx:12:8" data-component-path="src/app/activities/page.tsx" data-component-line="12" data-component-end-line="12" data-component-file="page.tsx" data-component-name="ActivitiesReferenceContent" data-component-content="%7B%22elementName%22%3A%22ActivitiesReferenceContent%22%7D" />
      </main>
      <PublicFooter data-component-id="src/app/activities/page.tsx:14:6" data-component-path="src/app/activities/page.tsx" data-component-line="14" data-component-end-line="14" data-component-file="page.tsx" data-component-name="PublicFooter" data-component-content="%7B%22elementName%22%3A%22PublicFooter%22%7D" />
    </>
  );
}


